<template>
  <div class="container">
    <div v-for="(hint, index) in reduceList" :key="index">
      <transition name="fade">
        <Hint
          v-if="hint.display"
          :content="hint.content"
          :index="index"
          :read="hint.read"
          @close="closeHints()"
          @continue="increment(hint.id)"
        />
      </transition>
    </div>
    <div class="background">
      <transition name="fade">
        <LivingRoom v-if="displayPartOne" @goToPartTwo="togglePartTwo" />
      </transition>
      <transition name="fade">
        <Budapest v-if="displayPartTwo" @goToPartThree="togglePartThree" />
      </transition>
      <transition name="fade">
        <LivingRoom2 v-if="displayPartThree" @goToPartFour="togglePartFour" />
      </transition>
      <transition name="fade">
        <Office
          v-if="displayPartFour"
          :cryptexOpened="openCryptex"
          :inputList="inputs"
          :user="user"
          :hints="hints"
          :startTime="startTime"
          @update="openCryptex = $event"
        />
      </transition>
    </div>
    <div
      @mouseover="isHovering = true"
      @mouseleave="isHovering = false"
      :class="isHovering ? 'footer show' : 'footer hide'"
    >
      <div v-if="isHovering" class="footer-content">
        <div>
          <h1>⏱ {{ duration }}</h1>
          <h1>💡 {{ hints }}</h1>
          <h1>- - - - - - -</h1>
          <h1
            :class="displayPartOne ? 'link selected' : 'link'"
            @click="togglePartOne"
          >
            1 - L'appartement
          </h1>
          <h1
            v-if="oneDone"
            :class="displayPartTwo ? 'link selected' : 'link'"
            @click="togglePartTwo"
          >
            2 - Budapest
          </h1>
          <h1
            v-if="twoDone"
            :class="displayPartThree ? 'link selected' : 'link'"
            @click="togglePartThree"
          >
            3 - Retour à l'appartement
          </h1>
          <h1
            v-if="threeDone"
            :class="displayPartFour ? 'link selected' : 'link'"
            @click="togglePartFour"
          >
            4 - Le bureau
          </h1>
        </div>
        <div v-if="!displayPartOne">
          <h1>- - - - - - -</h1>
          <div v-for="(hint, index) in reduceList" :key="index">
            <h3
              :class="getClass(hint, index)"
              @click="display(hint.id, hint, index)"
            >
              Indice n°{{ index + 1 }}
            </h3>
          </div>
        </div>
      </div>
      <div v-if="!isHovering" class="footer-content">
        <h1 class="hide-content">></h1>
        <h1 v-if="!displayPartOne" class="hide-content blink">💡</h1>
      </div>
    </div>
  </div>
</template>

<script>
import LivingRoom from "./Escape/LivingRoom.vue";
import LivingRoom2 from "./Escape/LivingRoom2.vue";
import Budapest from "./Escape/Budapest.vue";
import Office from "./Escape/Office.vue";
import Hint from "./Escape/Hint";

import { inputs, data } from "./Escape/data.js";
import randomName from "../helpers/generateName.js";

export default {
  name: "Escape",
  components: {
    LivingRoom,
    LivingRoom2,
    Budapest,
    Office,
    Hint,
  },
  data() {
    return {
      elapsedTime: null,
      startTime: 0,
      hints: 0,
      hintList: data,
      timer: 0,
      user: randomName,
      displayContest: true,
      isHovering: false,
      oneDone: false,
      twoDone: false,
      threeDone: false,
      displayPartOne: true,
      displayPartTwo: false,
      displayPartThree: false,
      displayPartFour: false,
      openCryptex: false,
      inputs: inputs,
    };
  },
  methods: {
    startTimer() {
      this.startTime = new Date();
      this.timer = setInterval(() => {
        this.elapsedTime += 1000;
      }, 1000);
    },
    togglePartOne() {
      this.hideAll();
      this.displayPartOne = true;
    },
    togglePartTwo() {
      this.hideAll();
      this.displayPartTwo = true;
      this.oneDone = true;
    },
    togglePartThree() {
      this.hideAll();
      this.displayPartThree = true;
      this.twoDone = true;
    },
    togglePartFour() {
      this.hideAll();
      this.displayPartFour = true;
      this.threeDone = true;
    },
    hideAll() {
      this.displayPartOne = false;
      this.displayPartTwo = false;
      this.displayPartThree = false;
      this.displayPartFour = false;
    },
    closeHints() {
      this.hintList.forEach((h) => {
        h.display = false;
      });
    },
    display(id, hint, index) {
      if (this.getClass(hint, index) === "inactive") return;
      this.closeHints();
      this.hintList.find((h) => h.id === id).display = true;
    },
    getClass(hint, index) {
      if (this.hintList.find((h) => h.id === hint.id).read) return "read";
      if (index === 0) return "active";
      if (this.reduceList[index - 1].read) return "active";
      return "inactive";
    },
    increment(id) {
      this.hintList.find((h) => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.hints += 1;
    },
    launch() {
      this.$http
        .post("https://mystery-engine.herokuapp.com/api/new", {
          game_log: {
            name: this.user,
            duration: 0,
            enigme: "escape",
            status: "started",
            hint: 0,
          },
        })
        .then(
          function(response) {
            // Success
            console.log("session started", response.data);
          },
          function(response) {
            // Error
            console.log(response.data);
          }
        );
    },
  },
  computed: {
    duration() {
      const date = new Date(null);
      date.setSeconds(this.elapsedTime / 1000);
      const utc = date.toUTCString();
      return utc.substr(utc.indexOf(":") - 2, 8);
    },
    reduceList() {
      if (this.displayPartTwo)
        return this.hintList.filter((h) => h.vue === "budapest");
      if (this.displayPartThree)
        return this.hintList.filter((h) => h.vue === "appartment");
      if (this.displayPartFour && !this.openCryptex)
        return this.hintList.filter((h) => h.vue === "office");
      if (this.displayPartFour && this.openCryptex)
        return this.hintList.filter((h) => h.vue === "final");
      return [];
    },
  },
  created: function() {
    this.startTimer();
    this.launch();
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Orbitron:wght@400;600;800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=VT323&display=swap");
h1 {
  font-family: "VT323", monospace;
  font-size: 28px;
  color: rgb(40, 40, 40);
  font-weight: bolder;
}
h3 {
  font-family: "VT323", monospace;
  color: rgb(40, 40, 40);
  font-weight: bolder;
}
p {
  font-family: "VT323", monospace;
  font-size: 20px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.center {
  display: flex;
  justify-content: center;
}
.container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgb(40, 40, 40);
}
.background {
  bottom: 0;
  right: 0;
  top: 0;
  position: relative;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  background: rgba(47, 79, 79, 0.6);
  background-image: linear-gradient(
    to bottom left,
    rgba(47, 79, 79, 0.6),
    rgb(50, 50, 50, 0.6)
  );
}
.hide {
  width: 32px;
  background: rgba(47, 79, 79, 0.6);
  transition: width 0.4s, background 1s;
}
.show {
  width: 300px;
  background: rgba(230, 230, 230, 0.8);
  transition: width 0.4s, background 1s;
}
.footer-content {
  width: 100%;
  height: 100%;
  text-align: center;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.hide-content {
  color: white;
  text-shadow: 0px 0px 3px white;
}
.link:hover {
  color: green;
  cursor: pointer;
}
.selected {
  text-decoration: underline;
}
.inactive {
  cursor: not-allowed;
  color: #ce322c;
}
.active {
  cursor: pointer;
  color: #faa806;
}
.read {
  cursor: pointer;
  color: #01593b;
}
@keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.blink {
  -webkit-animation: blink 2s linear infinite;
  -moz-animation: blink 2s linear infinite;
  animation: blink 2s linear infinite;
}
</style>
